import { useSelector } from 'react-redux';

import { getInquiryDetailsSelector } from 'store/inquiryDetails/selectors';

export const useShowLatestSignedContract = () => {
  const inquiryDetails = useSelector(getInquiryDetailsSelector);
  return Boolean(inquiryDetails?.finalSignedContract);
};
